import type { AssistantConversationSummary } from '../../../services/assistantCentral';

export const ASSISTANT_CONV_STATUS: Record<
  string,
  { label: string; color: 'default' | 'success' | 'warning' | 'info' }
> = {
  open: { label: 'Aberta', color: 'info' },
  resolved: { label: 'Resolvida', color: 'success' },
  escalated: { label: 'Encaminhada', color: 'warning' },
};

export function formatAssistantConversationTime(value?: string): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const sameDay =
    d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
  if (sameDay) {
    return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function conversationListTitle(c: AssistantConversationSummary): string {
  return c.title?.trim() || 'Conversa sem título';
}
